import { render, staticRenderFns } from "./CustomerField.vue?vue&type=template&id=47673467&scoped=true&"
import script from "./CustomerField.vue?vue&type=script&lang=js&"
export * from "./CustomerField.vue?vue&type=script&lang=js&"
import style0 from "./CustomerField.vue?vue&type=style&index=0&id=47673467&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47673467",
  null
  
)

export default component.exports